/* global jQuery */

$(function () {
	jQuery.support.cors = true;
	if (document.getElementById("side-column")) {
		$("#breadcrumbs-wrapper").addClass("clickable-breadcrumb");

		// Make clicking of the entire breadcrumb bar open the menu on mobile sizes
		$("#breadcrumbs-wrapper").click(function () {
			if (window.innerWidth < 840) {
				$("#side-column-wrapper").toggleClass("active");
				$("#submenu-icon").toggleClass("open");
			}
		});

		$("#side-column .dropdown-box > .title").click(function (e) {
			var $e = $(e.currentTarget).parent();
			$e.toggleClass("open");
		});

		$("#side-column .menu").click(function (e) {
			$("#side-column .submenu-wrapper").removeClass("open");
			$(e.currentTarget).find(".submenu-wrapper").addClass("open");
		});
	}

	$(".infobar").click(function (e) {
		if (e.target.className.indexOf("infobar-hide") >= 0) {
			$(this).hide();
			AoPS.fixFooter();
			$("#main-content").trigger($.Event("resize"));
			$.ajax({
				url: "/ajax.php",
				timeout: 5000,
				type: "post",
				data: {
					a: "infobar-hide",
					key: $(this).data("key"),
				},
				success: function (data) {},
			});
		}
	});

	$("#menu-myaops-toggle").click(function (e) {
		$("#menu-myaops").toggle();
		e.preventDefault();
		e.stopPropagation();
	});

	// Remove the bars for sidemenu dropdown if no sidemenu
	if (!document.getElementById("side-column")) {
		var dom = document.getElementById("submenu-icon");
		if (dom) {
			dom.parentNode.removeChild(dom);
		}
	}

	// Handle unimitate button
	$(".unimitate-btn").click(function (e) {
		$.ajax({
			url: "/ajax.php",
			timeout: 5000,
			type: "post",
			data: {
				a: "unimitate",
			},
			success: function () {
				window.location.reload();
			},
		});
	});

	AoPS.fixFooter();

	/** Reset the minimum height on page size change **/
	$(window).on("resize.fix_footer", function () {
		AoPS.fixFooter();
	});

	// If user is restricted (i.e. not allowed to use Online), show an
	// inescapable modal.
	if (
		AoPS.bootstrap_data &&
		AoPS.bootstrap_data.platform_user_info &&
		AoPS.bootstrap_data.platform_user_info.is_restricted &&
		!AoPS.session.initialized
	) {
		AoPS.showRestrictedModal(AoPS.bootstrap_data.platform_user_info);
	}

	if (AoPS.bootstrap_data && AoPS.bootstrap_data.banned_reason) {
		AoPS.showBannedModal(AoPS.bootstrap_data.banned_reason);
	}

	AoPS.login.initialize();
	AoPS.inputPlaceholders.initialize();

	// Apply svg or no-svg class to html tag
	if (
		!!document.createElementNS &&
		!!document.createElementNS("http://www.w3.org/2000/svg", "svg")
			.createSVGRect
	) {
		$("html").addClass("svg");
	} else {
		$("html").addClass("no-svg");
	}

	// Set the language to english
	$("html").attr("lang", "en");

	var $body = $("body"),
		$top_bar = $("#top-bar"),
		$main_logo = $("#main-logo"),
		start_over_bar = false,
		over_bar = false,
		over_logo = false,
		scroll_time = 150,
		scroll_delay = 350,
		start_over_logo = false;

	/** Dealing with what to do if the cursor is at the top of the page on load.  Don't want the stuff to scroll
	 in right when they start moving.  This is particularly weird when user has just clicked to company pages **/
	$top_bar.on("mousemove.start_loc", function () {
		start_over_bar = true;
	});
	$main_logo.on("mousemove.start_loc", function () {
		start_over_logo = true;
	});
	$body.on("mousemove.start_loc", function () {
		$top_bar.off("mousemove.start_loc");
		$body.off("mousemove.start_loc");
		$main_logo.off("mousemove.start_loc");
		setTimeout(function () {
			start_over_bar = false;
			start_over_logo = false;
		}, 350);
	});

	$top_bar.on("mouseenter", function () {
		over_bar = true;
		setTimeout(function () {
			if (!start_over_bar && over_bar) {
				$("#header-popin").animate(
					{
						//					top : 0
						opacity: 1,
					},
					scroll_time
				);
			}
		}, scroll_delay);
	});

	$main_logo.on("mouseenter", function () {
		over_logo = true;
		setTimeout(function () {
			if (!start_over_logo && over_logo) {
				$("#header-popin").animate(
					{
						//					top : 0
						opacity: 1,
					},
					scroll_time
				);
			}
		}, scroll_delay);
	});

	$top_bar.on("mouseleave", function () {
		over_bar = false;
	});

	$main_logo.on("mouseleave", function () {
		over_logo = false;
	});

	$("#header").on("mouseleave", function () {
		$("#header-popin").animate(
			{
				//			top : '-30px'
				opacity: 0,
			},
			scroll_time
		);
	});

	// Initialize rich dropdowns on top-bar.
	(function initializeRichDropdown() {
		/**
		 * The default left value of the dropdown.
		 * This should match the left value of .site-dropdown-wrapper
		 * in sharedsite.css.
		 */
		var DROPDOWN_MIN_LEFT = -100;

		/**
		 * The minimum number of pixels between the right edge of the dropdown
		 * and the right edge of the viewport.
		 */
		var MIN_RIGHT_MARGIN = 10;

		var $sites = $top_bar.find(".site");
		$sites.hover(
			function onSiteHoverIn() {
				// What to do when the user hovers over a .site.
				var $site = $(this);
				$site.addClass("dropdown-visible");
				if ($site.find(".site-dropdown-wrapper-b").length) {
					$site.addClass("dropdown-visible-b");
				}

				var $dropdown = $site.find(".site-dropdown-wrapper");
				if (!$dropdown.length) {
					return;
				}

				// Compute how many px the dropdown is overflowing the viewport.
				var window_width = $(window).width();
				var dropdown_width = $dropdown.outerWidth();
				var dropdown_left = $dropdown.offset().left;
				var overflow =
					dropdown_left + dropdown_width + MIN_RIGHT_MARGIN - window_width;

				if ($site.find(".site-dropdown-wrapper-b").length) {
					overflow -= 10;
				}
				// Correct it.
				if (overflow > 0) {
					$dropdown.css("left", DROPDOWN_MIN_LEFT - overflow + "px");
				}
			},
			function onSiteHoverOut() {
				// What to do when the user hovers out of a .site
				var $site = $(this);
				$site
					.removeClass("dropdown-visible")
					.removeClass("dropdown-visible-b")
					.find(".site-dropdown-wrapper")
					.css("left", "");
			}
		);
	})();

	AoPS.checkPrivacy();
	setTimeout(() => {
		AoPS.showAccountWarningModal();
	}, 500);
	AoPS.logSecretMessage();
});

$(window).on("load", function () {
	AoPS.fixFooter();
});

AoPS.logSecretMessage = function () {
	// Display super secret message yeah!
	var SECRET_MESSAGE_TEXT =
		"Oh hey! Fancy meeting you here. If you are reading this, congratulations, you may be on the very first step of your new journey with AoPS. We're building a team of Computer Science educators and are always looking for excellent software engineers. Learn more at https://aops.com/careers.";
	var SECRET_MESSAGE_STYLE = `
        font-size: 14px;
        margin: 0.5em;
        padding: 1em;
    `;
	console.log(`%c${SECRET_MESSAGE_TEXT}`, SECRET_MESSAGE_STYLE);
};

AoPS.checkPrivacy = function () {
	if (
		document.URL.indexOf("/privacy") < 0 &&
		AoPS.session &&
		AoPS.session.show_privacy
	) {
		var html = [
			"<p>We've made a few updates to our privacy policy. These updates went into effect on Thursday, August 1, 2024.</p>",
			"<p>Click ",
			'<a href="' +
				AoPS.aops_url +
				'company/privacy" target="_blank">here</a> ',
			"to learn more about the new ",
			'<a href="' +
				AoPS.aops_url +
				'" target="_blank">artofproblemsolving.com</a> policy.</p>',
			// 			"<p>Click ",
			// 			'<a href="' +
			// 				AoPS.academy_url +
			// 				'legal/privacy" target="_blank">here</a> ',
			// 			"to learn more about the new ",
			// 			'<a href="' +
			// 				AoPS.academy_url +
			// 				'" target="_blank">aopsacademy.org</a> policy.</p>',
		];

		var timeout = 1;
		var href = document.location.href;
		if (
			href.indexOf("community") > 0 ||
			href.indexOf("alcumus") > 0 ||
			href.indexOf("baeditor") > 0 ||
			href.indexOf("class/") > 0
		) {
			timeout = 1000;
		}

		setTimeout(function () {
			// eslint-disable-next-line no-alert
			alert(html.join(""), {
				onButtonClick: function () {
					$.post("/ajax.php", {
						action: "update-accepted",
					});
				},
				max_width: "600px",
				closeX: false,
				force_response: true,
			});
		}, timeout);
	}
};

// TODO PLATFORM (PROJ-12073): Remove after Platform accounts are all merged
/**
 * Shows a modal that tells the user to update their email because it
 * will conflict with another account during Platform merge. See
 * https://docs.google.com/document/d/1WK3tHLT_v1T1Hh31GoKyfWDw8R_NqJe2uPzl_yKmWWo/edit#heading=h.3uq3e628edtw
 */
AoPS.showAccountWarningModal = function () {
	if (AoPS.bd && AoPS.bd.showAccountMergeWarning && AoPS.bd.accountMergeCms) {
		// eslint-disable-next-line no-alert
		AoPS.Ui.Modal.showButtonsQuick(
			AoPS.bd.accountMergeCms,
			[{text: "Update Email"}],
			function () {
				var email = $("#account-merge-email-input").val();
				if (!AoPS.Utils.isValidEmail(email)) {
					$("#account-warning-error")
						.text("Please enter a valid email.")
						.show();
					return;
				}
				$.post(
					"/ajax.php",
					{
						a: "update-email",
						email,
					},
					function (data) {
						if (data && data.error_msg) {
							$("#account-warning-error").text(data.error_msg).show();
						} else {
							$("#account-warning-error").html("").hide();
							AoPS.Ui.Modal.closeTopModal();
							var thanks = [
								"<p>Thank you. Please check your inbox and verify your email to finish completing your email update.</p>",
							];
							AoPS.Ui.Modal.showAlertQuick(thanks);
						}
					}
				);
			},
			{
				max_width: "600px",
				closeX: false,
				force_response: true,
				close_on_button_click: false,
			}
		);
	}
};

// Set up AoPS alerts
window.classicAlert = window.alert;

/**
 * @param {string|jQuery|object|HTMLElement} message
 * @param {ModalOption} options
 */
window.alert = function (message, options) {
	if (AoPS.hasOwnProperty("Ui")) {
		AoPS.Ui.Modal.closeTopModal();
		if (typeof options === "undefined") {
			AoPS.Ui.Modal.showAlertQuick(message);
		} else {
			AoPS.Ui.Modal.showAlertQuick(message, options);
		}
	} else {
		window.classicAlert(message);
	}
};

/**
 * Set the breadcrumbs in the breadcrumb bar
 *
 * @param {{text: string, url: string?}[]} crumbs An array of objects containing the breadcrumbs. Each
 *                object should be formatted as:
 *                {
 *                    text : breadcumb text,
 *                    url : URL to link to when user clicks on breadcrumb (optional)
 *                }
 */
AoPS.setBreadcrumbs = function (crumbs) {
	var content;

	var html = [];

	for (var i = 0; i < crumbs.length; i++) {
		content = crumbs[i].text;
		if (crumbs[i].url) {
			content = '<a href="' + crumbs[i].url + '">' + content + "</a>";
		}

		html.push(
			'<span class="crumb crumb-' + (i + 1) + '">' + content + "</span>"
		);
	}

	$(".crumb-wrapper").html(
		html.join(' <i class="aops-font aops-angle-double-right"></i> ')
	);
};

AoPS.fixFooter = function () {
	// Determine minimum height of #main-content
	var height = $(window).height();
	var has_small = $("body").hasClass("small-footer");

	height -= $("#header-wrapper").outerHeight();
	height -= $("#top-bar").outerHeight();
	if (!$("#breadcrumbs-wrapper:visible").length) {
		height -= 26; //breadcrumb height
	}

	if (has_small) {
		height -= $("#small-footer-wrapper").outerHeight();
	} else {
		height -= $("#main-footer").outerHeight();
	}

	$("#main-content").css("min-height", height);

	if (has_small) {
		$("#small-footer-wrapper").show();
	}

	var sidebar = document.getElementById("side-column-wrapper");
	if (sidebar) {
		$(sidebar).css("min-height", height);
	}

	AoPS.fixSidebarOnce();
};

// A helper for all fixSidebar functions
// Will check if an adjustment is needed, and make the adjustion if needed
AoPS.makeSidebarAdjustment = function (
	$sidebarWrapper,
	$sidebar,
	$main_column
) {
	if (!$sidebarWrapper || !$sidebar || !$main_column) {
		return;
	}
	var totalInnerHeight = 0;
	$sidebar.children().each(function () {
		totalInnerHeight += $(this).outerHeight(true);
	});

	if (
		$sidebarWrapper.height() !==
		Math.max($main_column.outerHeight(true), totalInnerHeight)
	) {
		$sidebarWrapper.css(
			"height",
			Math.max($main_column.outerHeight(true), totalInnerHeight)
		);
	}
};

// Fix the sidebar, will adjust the height to the minimum
// of the main column and the content of the sidebar
AoPS.fixSidebarOnce = function () {
	var sidebarWrapper = $("#side-column-wrapper");
	var sidebar = $("#side-column");
	var main_column = $("#main-column");

	AoPS.makeSidebarAdjustment(sidebarWrapper, sidebar, main_column);
};

// Constantly checking the sidebar, and will fix it if
// needed for the duration of length. The adjustment
// is immediate but will look animated if the main column
// is animated
//
// length(int): the duration of the checking/fixing in milliseconds
AoPS.fixSidebarAnimatedOnce = function (length) {
	AoPS.fixSidebarAnimatedOnceOnElement(length, "main-column");
};

// This can be used when there main column has a different id
AoPS.fixSidebarAnimatedOnceOnElement = function (length, id) {
	var sidebarWrapper = $("#side-column-wrapper");
	var sidebar = $("#side-column");
	// var main_column = $("#" + id);
	var limit = 2 + length ? length / 15 : 0;

	var ct = 0;
	var sidebarHeighAdjustAnimate = function () {
		if (ct > limit) {
			return;
		}
		ct++;
		AoPS.makeSidebarAdjustment(sidebarWrapper, sidebar, $("#" + id));
		setTimeout(sidebarHeighAdjustAnimate, 15);
	};
	sidebarHeighAdjustAnimate();
};

// Observing class changes on main column and it's descendants
//
// Options:
//		attributeFilter(list of string): can be used to observe styles, or both class and style, see
//         https://developer.mozilla.org/en-US/docs/Web/API/MutationObserverInit/attributeFilter for details
//    animation_length(int): deal with animatation/unsynchronized loading.
//         The length for checking/fixing when ever the observer calls the callback. In milisecond.
AoPS.fixSidebarClassObserver = function (option) {
	var sidebarWrapper = $("#side-column-wrapper");
	var sidebar = $("#side-column");
	var main_column = $("#main-column");

	var config;
	if (!option) {
		option = [];
	}

	if (!option["attributeFilter"]) {
		config = {
			attributeFilter: ["class"],
			attributes: true,
			childList: true,
			subtree: true,
		};
	} else {
		config = {
			attributeFilter: option["attributeFilter"],
			attributes: true,
			childList: true,
			subtree: true,
		};
	}

	var adjustSidebarHeight = function () {
		if (option["animation_length"]) {
			var limit = 2 + option["animation_length"] / 15;

			var ct = 0;
			var sidebarHeighAdjustAnimate = function () {
				if (ct > limit) {
					return;
				}
				ct++;
				AoPS.makeSidebarAdjustment(sidebarWrapper, sidebar, main_column);
				setTimeout(sidebarHeighAdjustAnimate, 15);
			};

			sidebarHeighAdjustAnimate();
		} else {
			AoPS.makeSidebarAdjustment(sidebarWrapper, sidebar, main_column);
		}
	};

	var observer = new MutationObserver(adjustSidebarHeight);
	observer.observe(document.getElementById("main-column"), config);

	if (option["animation_length"]) {
		AoPS.fixSidebarAnimatedOnce(option["animation_length"] / 15);
	} else {
		AoPS.makeSidebarAdjustment(sidebarWrapper, sidebar, main_column);
	}
};

AoPS.showRestrictedModal = function (platform_user) {
	var username = platform_user.username;
	var email = platform_user.email;
	var currentUrl = encodeURIComponent(window.location.href);
	var signinUrl = encodeURIComponent(AoPS.getSigninURL());
	var $restricted_modal = $("<div />").text(
		`You cannot use this site as ${
			username || email
		}. Sign out or switch to a different account to use this site.`
	);

	$restricted_modal.showModalQuick({
		max_width: "50%",
		type: "buttons",
		buttons: [
			{
				text: "Sign out",
				value: "signout",
			},
			{
				text: "Switch accounts",
				value: "switch",
			},
		],
		closeX: false,
		force_response: true,
		onButtonClick: function (value) {
			if (value === "signout") {
				window.location = `/signout?requestedPage=${currentUrl}`;
			} else if (value === "switch") {
				window.location = `/signout?requestedPage=${signinUrl}`;
			}
		},
	});
};

AoPS.displayCoppaBlockedModal = function (opts = {escapable: false}) {
	AoPS.Ui.Modal.showMessage(
		"The Children's Online Privacy Protection Act (COPPA) requires us to collect parental permission prior to you being able to use your account. Please have your parent fill out and return the <a href='/company/coppa-form' target='_blank'>parental permission form</a>.",
		{
			closeX: !!opts.escapable,
			force_response: !opts.escapable,
		}
	);
};

AoPS.showBannedModal = function (bannedReason) {
	AoPS.Ui.Modal.showMessage(bannedReason, {
		title: "Account Deactivated",
		closeX: false,
		force_response: true,
	});
};

AoPS.getSigninURL = function () {
	var redirectUrl = window.location.href;
	var redirectPath = window.location.pathname;

	// If coming from the email confirmation page, just redirect back to
	// the home page.
	if (redirectPath.startsWith("/user/activate/")) {
		redirectUrl = window.location.protocol + "//" + window.location.hostname;
	}

	return `/signin?requestedPage=${encodeURIComponent(redirectUrl)}`;
};

AoPS.login = {
	/**
	 * Flag indicating if an ajax call is currently taking place.
	 * Prevents users clicking over and over.
	 *
	 * @type Boolean
	 */
	ajaxing: false,

	logout_url: AoPS.bootstrap_data && AoPS.bootstrap_data.logout_url,

	user_clicked_logout: false,

	user_clicked_login: false,

	modal: null,

	initialize: function () {
		$(document).on("click", ".online-login-button", AoPS.login.display);
		$(document).on("click", ".online-initialize-button", () => {
			AoPS.Initialize.display({escapable: true});
		});
		$(document).on("click", ".online-needs-coppa-button", () => {
			AoPS.displayCoppaBlockedModal({escapable: true});
		});
		$(document).on("click", ".online-register-button", AoPS.login.goToRegister);
		$("#header-logout, #small-header-logout").on("click", AoPS.login.logout);
		$("#register-button").on("click", function (e) {
			e.preventDefault();
			AoPS.login.register();
		});
	},

	logout: function (e) {
		window.location.href = `/signout?requestedPage=${encodeURIComponent(
			window.location.href
		)}`;
		return;
	},

	register: function () {
		var username = document.getElementById("login-username").value || "";
		var password = document.getElementById("login-password").value || "";

		// If an inline-register is defined for this page, call that.
		if (typeof (AoPS.Register || {}).display === "function") {
			AoPS.Register.display({
				username: username,
				password: password,
			});
		} else {
			var form = document.getElementById("registration-form");
			form.username.value = username;
			form.password.value = password;
			form.submit();
		}
	},

	goToRegister: function () {
		// Opting for a function instead of direct link in case we want to
		// do anything special upon registration, like redirect to
		// original page.
		if (typeof (AoPS.Register || {}).display === "function") {
			// Show registration modal, if it exists.
			AoPS.Register.display({});
		} else {
			// Redirect to register page.
			window.location.href = `/user/register`;
			return;
		}
	},

	/**
	 * Log the user in
	 */

	loggedin: function () {},

	display: function () {
		window.location.href = AoPS.getSigninURL();
		return;
	},

	/**
	 * Call this function if Ajax has decided you are logged out.
	 *  Resets the Log In/User header and resets the action for clicking on that
	 *  header.
	 **/
	onUserAjaxLogout: function () {
		if (!AoPS.session.logged_in) {
			$("#header .myaops").remove();
			$("#header-login").show();
		}
	},

	/**
	 * Call this function if Ajax has decided you are logged in.
	 *  Resets the header and resets the action for clicking on that
	 *  header.
	 **/
	onUserAjaxLogin: function () {
		document.location.reload(true);
	},
};

// Set up drop down menus
$(function () {
	var $dropdowns = $(".menubar-label, .login-dropdown");

	var touching = false;

	/**
	 * Mouse events
	 *
	 * @description Mimic hoverIntent plugin by waiting for the mouse to 'settle' within the target before triggering
	 */
	$dropdowns
		.on("click", function (e) {
			if (touching) {
				e.preventDefault();
				e.stopPropagation();
			}

			// Deal with clicks on my aops menu which differs from regular menus
			// e.target points to the dom clicked, currentTarget points to myaops
			// if (e.target.className.indexOf("username") >= 0) {
			// 	if (e.currentTarget.className.indexOf("open") > 0) {
			// 		e.currentTarget.className = e.currentTarget.className.replace(
			// 			"open",
			// 			""
			// 		);
			// 	} else {
			// 		e.currentTarget.className += " open";
			// 	}
			// 	e.stopPropagation();
			// 	e.preventDefault();
			// }
		})
		.on("mouseover", function (e) {
			if (touching) {
				e.preventDefault();
				return;
			}

			var $this = $(this);
			if ($this.prop("hoverTimeout")) {
				$this.prop("hoverTimeout", clearTimeout($this.prop("hoverTimeout")));
			}

			$this.prop(
				"hoverIntent",
				setTimeout(function () {
					$this.addClass("open");
				}, 50)
			);
		})
		.on("mouseleave", function (e) {
			if (touching) {
				e.preventDefault();
				return;
			}

			var $this = $(this);

			if ($this.prop("hoverIntent")) {
				$this.prop("hoverIntent", clearTimeout($this.prop("hoverIntent")));
			}

			$this.prop(
				"hoverTimeout",
				setTimeout(function () {
					$this.removeClass("open");
				}, 50)
			);
		});

	/**
	 * Touch events
	 *
	 * @description Support click to open if we're dealing with a touchscreen
	 */
	var event = window.navigator.msPointerEnabled
		? "MSPointerDown"
		: "touchstart";
	if ("ontouchstart" in document.documentElement || event === "MSPointerDown") {
		$dropdowns.each(function () {
			var $this = $(this);

			this.addEventListener(
				event,
				function (e) {
					if (event === "MSPointerDown" || e.touches.length === 1) {
						if (window.innerWidth > 700 || $this.hasClass("login-dropdown")) {
							// Prevent touch events within dropdown bubbling down to document
							e.stopPropagation();
							// Toggle hover
							if (!$this.hasClass("open")) {
								// Prevent link on first touch
								touching = true;
								if (e.target === this || e.target.parentNode === this) {
									e.preventDefault();
								}

								// Hide other open dropdowns
								$dropdowns.removeClass("open");
								$this.addClass("open");

								// Hide dropdown on touch outside
								var closeDropdown = function (e2) {
									e2.stopPropagation();
									$this.removeClass("open");
									document.removeEventListener("touchstart", closeDropdown);
									touching = false;
								};
								document.addEventListener(event, closeDropdown);
							} else {
								// Allow next touch to act as a click
								touching = false;
							}
						} else {
							//At small window widths, menu controlled by navheader.js
						}
					}
				},
				false
			);
		});
	}
});

/**
 * Updates the footer and side bar to appropriate positions and sizes.
 * What a pain in the but this was. And it's not even done yet becase
 * we have not taken into account the small footer. We'll deal with
 * that when the time comes.
 * NVM...not used.
 */
AoPS.updateLayout = function () {
	return;
};

if (typeof Backbone !== "undefined") {
	AoPS.Model = Backbone.Model.extend({});

	AoPS.Collection = Backbone.Collection.extend({
		debug: function () {
			console.log(this);
			console.log(this.length);
			console.log(this.models);
		},
	});

	AoPS.View = Backbone.View.extend({
		getTemplate: function (template_selector, data) {
			var template = AoPS.View.compileTemplate(template_selector);
			return $.parseHTML($.trim(template && template(data)));
		},

		/**
		 * Compile handlebars template
		 *
		 * @return {function}
		 */
		compile: function (template_selector) {
			return AoPS.View.compileTemplate(template_selector);
		},

		/**
		 * Display the view
		 *
		 * @param {function} Handlebars template function
		 * @param {object} Data to send to handlebars template
		 */
		display: function (template, data) {
			this.$el.html($.parseHTML($.trim(template(data))));
		},

		debug: function () {
			console.log("View.model:", this.model);
			console.log("View.tagName:", this.tagName);
			console.log("View.className:", this.className);
			console.log("View.el:", this.el);
			console.log("View.$el:", this.$el);
		},

		hide: function () {
			this.$el.hide();
		},

		show: function () {
			this.$el.show();
		},

		close: function () {
			this.remove();
			this.unbind();
			if ("function" === typeof this.onClose) {
				this.onClose();
			}
		},

		/**
		 * Show an inescapable modal displaying our loading gif
		 */
		showLoadingModal: function () {
			this.loadingModal = AoPS.Ui.Modal.showMessage(
				'<img src="/assets/images/logo-loader.gif" />',
				{
					closeX: false,
					force_response: true,
					frame_class: "loading-modal-frame",
				}
			);
		},

		/**
		 * Close the loading modal object stored in this.loadingModal
		 */
		closeLoadingModal: function () {
			AoPS.Ui.Modal.closeParticularModal(this.loadingModal);
		},
	});

	AoPS.View.template_cache = {};
	// Memoized template compiling function. You can use this function even
	// without being in AoPS.View to share the global cache with everyone else.
	AoPS.View.compileTemplate = function (template_selector) {
		var cache = AoPS.View.template_cache;

		if (!cache.hasOwnProperty(template_selector)) {
			var direct = $(template_selector);
			var precompiled =
				Handlebars.templates &&
				Handlebars.templates[template_selector.slice(1)]; // Remove the #
			if (direct.length) {
				cache[template_selector] = Handlebars.compile(direct.html());
			} else if (precompiled) {
				cache[template_selector] = precompiled;
			}
		}
		return cache[template_selector];
	};
}

/**
 * Clear input placeholders. This is needed for IE 8 and 9. Yes, even 9. grrr.
 */
AoPS.inputPlaceholders = {
	initialize: function () {
		if (!("placeholder" in document.createElement("input"))) {
			// Set up quantity placeholders (shiv for IE 8 and 9)
			$("[placeholder]")
				.focus(function () {
					var input = $(this);
					if (input.val() === input.attr("placeholder")) {
						input.val("");
						input.removeClass("placeholder");
					}
				})
				.blur(function () {
					var input = $(this);
					if (input.val() === "" || input.val() === input.attr("placeholder")) {
						input.addClass("placeholder");
						input.val(input.attr("placeholder"));
					}
				})
				.blur();

			$(["placeholder"]).parents("form").submit(AoPS.inputPlaceholders.clear);

			AoPS.inputPlaceholders.clear = function () {
				$("[placeholder]").each(function () {
					var input = $(this);
					if (input.val() === input.attr("placeholder")) {
						input.val("");
					}
				});
			};
		}
	},

	clear: function () {},
};

/**
 * Speedy rendering of MathJax. Pass in a list of DOM elements, like a jQuery
 * object. The HTML inside each element will be replaced with the contents
 * after all MathJax has been rendered.
 *
 * @param elList. A jQuery object or an array of DOM elements.
 */
AoPS.doFastMathJax = function (elList) {
	AoPS.FastMathJax.push(elList);
};

// This is the helper that manages the global FastMathJax queue.
AoPS.FastMathJax = {
	_elements: [],
	_isProcessing: false,
	_process: function () {
		// Make sure that only one process is running.
		if (this._isProcessing) {
			return;
		}
		if (!this._elements.length) {
			this._isProcessing = false;
			return;
		} else {
			this._isProcessing = true;
		}

		// Create a hidden DIV and append it (important!)
		var $container = $("<div />")
			.css({
				position: "fixed",
				top: "-100vh",
				left: "-100vw",
				opacity: 0,
				"z-index": -9999,
				"pointer-events": "none",
			})
			.appendTo($(document.body));
		var self = this,
			spliced = this._elements.splice(0, 250);

		// Let each spliced object know what its corresponding hidden element is
		_.each(spliced, function (obj) {
			obj.$hidden = obj.$el.clone().removeClass().appendTo($container);
		});

		// Render!
		MathJax.Hub.Queue(["Typeset", MathJax.Hub, $container.get(0)]);

		// Post render.
		MathJax.Hub.Queue([
			function () {
				_.each(spliced, function (obj) {
					// Not using clone will cause Safari to get weird
					obj.$el.html("").append(obj.$hidden.clone());
					obj.$hidden.remove();
				});
				$container.remove();

				// Mark process as complete and clear out any leftovers.
				self._isProcessing = false;
				self._process();
			},
		]);
	},
	push: function (input) {
		if (window.MathJax) {
			if (input instanceof jQuery || _.isArray(input)) {
				_.each(
					input,
					_.bind(function (el) {
						this._elements.push({
							$el: $(el),
						});
					}, this)
				);
			} else {
				this._elements.push({
					$el: $(input),
				});
			}
			// We introduce a short delay before processing so that the flurry of elements can be queued.
			setTimeout(
				_.bind(function () {
					this._process();
				}, this),
				50
			);
		}
	},
};

/**
 * Dynamically load JavaScript file
 *
 * @param {string} uri
 */
AoPS.importJavaScript = function (uri) {
	var dom = document.createElement("script");
	dom.setAttribute("type", "text/javascript");
	dom.setAttribute("src", uri);
	document.getElementsByTagName("head")[0].appendChild(dom);
};

window.number_format = function (number, decimals, dec_point, thousands_sep) {
	//  discuss at: http://phpjs.org/functions/number_format/

	number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
	var n = !isFinite(+number) ? 0 : +number,
		prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
		sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
		dec = typeof dec_point === "undefined" ? "." : dec_point,
		s = "",
		toFixedFix = function (n2, prec2) {
			var k = Math.pow(10, prec2);
			return "" + (Math.round(n2 * k) / k).toFixed(prec2);
		};
	// Fix for IE parseFloat(0.55).toFixed(0) = 0;
	s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
	if (s[0].length > 3) {
		s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
	}
	if ((s[1] || "").length < prec) {
		s[1] = s[1] || "";
		s[1] += new Array(prec - s[1].length + 1).join("0");
	}
	return s.join(dec);
};

// An AoPS.refreshOnBackButtonLoadWithOldData function is defined here.
// Most browsers try to give you a cached version of the site if you access them
// via the back button. This is not good because it contains data that is out of
// date. This function tries to solve that. The fix requires users to have
// cookies enabled. If they do not have cookies turned on, they are out of luck
// and will see old data.
(function () {
	// No matter how many times AoPS.refreshOnBackButtonLoadWithOldData is called,
	//  this variable will be able to keep track of whether we have already tried to refresh.
	var already_tried_to_refresh = false;

	// This function will only ever fire once
	var refreshPage = function () {
		if (already_tried_to_refresh) {
			return;
		}
		already_tried_to_refresh = true;

		// Hide the page so that the user can't do crazy stuff while we're
		// waiting to refresh.
		// Do not just set display to none because it may be applied late.
		// document.getElementById("html").style.display = "none";
		var style = document.createElement("STYLE");
		var style_text = document.createTextNode("body {display: none;}");
		style.appendChild(style_text);
		document.head.appendChild(style);

		// Due to issues with users rapidly hitting the site that might have
		// been caused by this function (or might not have), we put a high
		// timeout interval on the window.location.reload to prevent it from
		// ever causing spammed requests on our site.
		// Even without the delay, a setTimeout of 0 is needed at minimum so
		// that the DOM manipulations above take effect.
		console.log("About to refresh the page due to back button use.");
		setTimeout(function () {
			window.location.reload(true);
		}, 2000);

		// Do not throw an error.
	};

	var getServerTime = function (server_time_bootstrap_name) {
		var server_time_raw = "" + AoPS.bootstrap_data[server_time_bootstrap_name];
		// If there isn't a valid time sent through from the backend, do not refresh.
		if (server_time_raw.indexOf(";") > -1) {
			return false;
		}
		return parseInt(server_time_raw) || false;
	};

	// Returns false if the cookie could not be found or is invalid or whatever.
	var getLastInitTimeCookie = function (this_name) {
		// Check if cookies are enabled.
		if (
			!document ||
			_.isUndefined(document.cookie) ||
			!navigator ||
			!navigator.cookieEnabled
		) {
			return false;
		}

		// Check each cookie to see if it is the cookie we are looking for.
		// If it is, return it.
		var re = new RegExp("^\\s*" + this_name + "_init_time\\s*=\\s*(.*?)\\s*$");
		var cookies = document.cookie.split(";");
		var found;
		for (var i = 0; i < cookies.length; i++) {
			found = cookies[i].match(re);
			if (found) {
				return parseInt(found[1]);
			}
		}

		return false;
	};

	var already_checked_for_old_data = false;
	AoPS.refreshOnBackButtonLoadWithOldData = function (
		this_name,
		server_time_bootstrap_name
	) {
		// Make sure we never do the code below more than once.
		if (already_checked_for_old_data) {
			return;
		}
		if (AoPS.bd.frozenTime) {
			return;
		}
		already_checked_for_old_data = true;

		// Parameter checking/defaults.
		if (!this_name) {
			return;
		}
		server_time_bootstrap_name = server_time_bootstrap_name || "init_time";

		// Get the server time. This is a time sent by the server in the loaded
		// HTML through the bootstrap_data mechanism. If the user uses the back
		// button and the browser reloads the data sent before without hitting
		// our server again, this will be out of date.
		var server_time = getServerTime(server_time_bootstrap_name);
		// If we couldn't fetch the server time, there is no point in even
		// trying to refresh or set a new cookie. Stop.
		if (server_time === false) {
			return;
		}

		// Get the cookie time. This is the last known server time sent to the
		// user's device, i.e. we set its value to the server_time computed
		// above, not to the time the user's browser thinks it is. If this time
		// is equal to or exceeds the server time above, we know that the user's
		// browser reloaded old HTML in a cache and that a refresh is needed.
		var cookie_time = getLastInitTimeCookie(this_name);

		// If we fetched a valid cookie time and it is at least as high as the
		// server time sent on this page load, we know we need to refresh.
		if (cookie_time !== false && cookie_time >= server_time) {
			refreshPage();
			return;
		}

		// Wait 3 seconds before setting the cookie. If the user goes off the
		// page and then "Back" buttons to it within 3 seconds, whatever the
		// reloaded data is can't be so new that we want to reload.
		// If we're refreshing, we don't want to set the cookie, since that
		// risks an infinite loop.
		setTimeout(function () {
			if (already_tried_to_refresh) {
				return;
			}
			document.cookie = this_name + "_init_time=" + server_time + "; path=/";
		}, 3000);
	};
})();

AoPS.isUserLimited = function () {
	return AoPS.user_is_limited;
};
AoPS.user_is_limited =
	AoPS.hasOwnProperty("session") &&
	AoPS.session.hasOwnProperty("role") &&
	AoPS.session.role.indexOf("limited_user") !== -1;

AoPS.isUserNew = function () {
	return AoPS.user_is_new;
};
AoPS.user_is_new =
	AoPS.hasOwnProperty("session") &&
	AoPS.session.hasOwnProperty("role") &&
	AoPS.session.role.indexOf("new_user") !== -1;
AoPS.isUserCoppaBlocked = () =>
	AoPS.hasOwnProperty("session") &&
	AoPS.session.hasOwnProperty("needs_coppa_approval") &&
	!!AoPS.session.needs_coppa_approval;
AoPS.in_academy =
	AoPS.bootstrap_data &&
	AoPS.bootstrap_data.hasOwnProperty("in_academy") &&
	parseInt(AoPS.bootstrap_data.in_academy) === 1;

AoPS.convertSmartQuotes = function (s) {
	return s
		.replace(/[\u2018\u2019]/g, "'")
		.replace(/[\u201C\u201D]/g, '"')
		.replace(/[\u2013\u2014]/g, "-")
		.replace(/[\u2026]/g, "...");
};

// Error logger
var gOldOnError = window.onerror;
window.onerror = function (msg, url, line, column, errorObj) {
	/*
	if ( window.jQuery && msg && url && line ) {
		$.post( "/ajax.php", {
			action : "log-error",
			message : msg,
			url : url,
			line : line,
			column : column ? column : "Unknown",
			error : errorObj ? errorObj.stack : "none"
		} );
	}
	*/

	if (gOldOnError) {
		return gOldOnError(msg, url, line);
	}

	// Just let default handler run.
	return false;
};

window.onImageLoad = function () {};

/**
 * Compile a handlebars template via dom, selector, or string.
 * If Handlebars is not loaded, do a simple search/replace.
 *
 * @param Element|jQuery|string dom May be an HTML element, jQuery object, DOM selector, or template.
 * @param Object data Data to embed in template
 * @return string
 */
window.handlebars = function (dom, data) {
	var text = "";
	if (!data) {
		data = {};
	}

	if (dom instanceof Element) {
		text = dom.innerHTML;
	} else if (typeof jQuery !== "undefined" && dom instanceof jQuery) {
		text = dom.html();
	} else if (typeof dom === "string") {
		try {
			var d = document.querySelector(dom);
			text = d === null ? dom : d.innerHTML;
		} catch (ex) {
			text = dom;
		}
	} else {
		return false;
	}

	if (typeof Handlebars !== "undefined") {
		return Handlebars.compile(text)(data);
	}

	// Super simple search/replace
	for (var key in data) {
		var regex = new RegExp("{{" + key + "}}", "g");
		text = text.replace(regex, data[key]);
	}

	return text;
};

AoPS.handleLocationHash = function ($tgt) {
	var getDestination = function ($target) {
		var targetTop = $target.offset().top;
		var menuBarHeight = $("#main-menubar").outerHeight();
		return Math.min(
			Math.floor(targetTop - menuBarHeight),
			Math.max(
				$("html").prop("scrollHeight") - $(window).height(),
				$("body").prop("scrollHeight") - $(window).height()
			)
		);
	};

	var vars = {};

	function scrollTo($target) {
		if (vars.animating) {
			return;
		}

		vars.animating = true;
		var destination = getDestination($target);
		$("html, body").animate(
			{
				scrollTop: destination,
			},
			{
				duration: 0,
				step: function (_, tween) {
					tween.end = getDestination($target);
				},
				always: function () {
					vars.animating = false;
					if (
						Math.abs($(window).scrollTop() - getDestination($target)) >
						vars.threshold
					) {
						scrollTo($target);
					}
				},
			}
		);
	}

	setTimeout(function () {
		if (location.hash) {
			var $anchor = $(document).find(location.hash);
			if ($anchor.length) {
				scrollTo($anchor);
			}
		}
	}, 0);
};

/**
 * This is hopefully an improvement on handleLocationHash.
 * As of Nov 2021, only used on new offerings course page.
 *
 * The original handleLocationHash function can sometimes be offset when
 * scrolling from the very top of the page vs scrolling from the middle of the page,
 * because of the dynamically hiding menu bar.
 *
 * This function should improve that and also improve scrolling on mobile view.
 *
 * @param {*} $tgt Target div to scroll to.
 * @param {*} opts Can specify scroll duration.
 */
AoPS.handleLocationHash2 = function ($tgt, opts) {
	if (!opts) {
		opts = {};
	}

	var getDestination = function ($target) {
		var header = $("#header");
		var mainMenuBar = $("#main-menubar");

		// We need to add a height offset for the fixed menubar at the top of the page.
		var menuBarHeight = mainMenuBar.outerHeight();

		// This means we're in mobile view and the header won't stay at the top of the page,
		// so we don't need to offset the scroll
		if ($(window).width() <= 700) {
			menuBarHeight = 0;
		} else {
			if (header.css("position") === "fixed") {
				menuBarHeight = mainMenuBar.outerHeight();
			} else {
				// We're scrolled to the top of the page, so things are a little more complicated.
				// The top "shared site" menu bar is going to disappear, which moves everything up,
				// so we need to add an extra offset of 70px.
				menuBarHeight = mainMenuBar.outerHeight() + 70;
			}
		}

		var targetTop = $target.offset().top;

		return Math.min(
			Math.floor(targetTop - menuBarHeight),
			Math.max(
				$("html").prop("scrollHeight") - $(window).height(),
				$("body").prop("scrollHeight") - $(window).height()
			)
		);
	};

	var vars = {};

	function scrollTo($target) {
		if (vars.animating) {
			return;
		}

		vars.animating = true;
		var destination = getDestination($target);

		$("html, body").animate(
			{
				scrollTop: destination,
			},
			{
				duration: opts && opts.duration ? opts.duration : 0,
				step: function (_, tween) {
					tween.end = getDestination($target);
				},
				always: function () {
					vars.animating = false;

					// Allow a 5px cushion. Using 0 breaks on mobile
					// because the values returned are floats.
					if (Math.abs($(window).scrollTop() - getDestination($target)) > 5) {
						opts.duration = 0;
						scrollTo($target);
					}
				},
			}
		);
	}

	setTimeout(function () {
		if ($tgt) {
			if ($tgt.length) {
				scrollTo($tgt);
			}
		} else if (location.hash) {
			var $anchor = $(document).find(location.hash);
			if ($anchor.length) {
				scrollTo($anchor);
			}
		}
	}, 0);
};

AoPS.Constants = {
	minUsernameLength: 3,
	maxUsernameLength: 25,
	minPasswordLength: 8,
};
